import React from 'react';
import './ContactSection.css';

const ContactSection: React.FC = () => {
  return (
    <section id="contact" className="contact-section">
      <div className="contact-background" />
      
      <div className="container">
        <div className="contact-container">
          
          {/* Section Header */}
          <div className="contact-header">
            <div className="contact-badge">
              <div className="contact-badge-dot" />
              Get In Touch
            </div>
            
            <h2 className="contact-title">Contact Nuroveli</h2>
            
            <p className="contact-subtitle">
              Ready to secure your digital future? Let's connect and discuss how we can protect your business.
            </p>
          </div>
          
          {/* Contact Grid */}
          <div className="contact-content">
            
            {/* Contact Information Cards */}
            <div className="contact-info-grid">
              
              {/* Office Location */}
              <div className="contact-card contact-card-location">
                <div className="contact-card-icon">
                  <i className="ri-map-pin-line"></i>
                </div>
                <h3 className="contact-card-title">Our Office</h3>
                <p className="contact-card-description">
                  123 Cybersecurity Avenue<br />
                  Tech District, Silicon Valley<br />
                  CA 94043, United States
                </p>
              </div>
              
              {/* Phone Contact */}
              <div className="contact-card contact-card-phone">
                <div className="contact-card-icon">
                  <i className="ri-phone-line"></i>
                </div>
                <h3 className="contact-card-title">Phone</h3>
                <p className="contact-card-description">
                  Main: +1 (555) 123-4567<br />
                  Support: +1 (555) 789-0123<br />
                  Emergency: +1 (555) 911-HELP
                </p>
                <a href="tel:+15551234567" className="contact-card-link">
                  <i className="ri-arrow-right-line"></i>
                  Call Now
                </a>
              </div>
              
              {/* Email Contact */}
              <div className="contact-card contact-card-email">
                <div className="contact-card-icon">
                  <i className="ri-mail-line"></i>
                </div>
                <h3 className="contact-card-title">Email</h3>
                <p className="contact-card-description">
                  General: info@nuroveli.com<br />
                  Sales: sales@nuroveli.com<br />
                  Support: support@nuroveli.com
                </p>
                <a href="mailto:info@nuroveli.com" className="contact-card-link">
                  <i className="ri-arrow-right-line"></i>
                  Send Email
                </a>
              </div>
              
              {/* Business Hours */}
              <div className="contact-card contact-card-hours">
                <div className="contact-card-icon">
                  <i className="ri-time-line"></i>
                </div>
                <h3 className="contact-card-title">Business Hours</h3>
                <p className="contact-card-description">
                  Monday - Friday: 9:00 AM - 6:00 PM PST<br />
                  Saturday: 10:00 AM - 4:00 PM PST<br />
                  Sunday: Emergency Support Only
                </p>
              </div>
              
            </div>
            
            {/* Social Media Links */}
            <div className="contact-social">
              <h3 className="contact-social-title">Follow Us</h3>
              <div className="contact-social-links">
                <a href="https://linkedin.com/company/nuroveli" className="contact-social-link" target="_blank" rel="noopener noreferrer">
                  <i className="ri-linkedin-line"></i>
                  <span>LinkedIn</span>
                </a>
                <a href="https://twitter.com/nuroveli" className="contact-social-link" target="_blank" rel="noopener noreferrer">
                  <i className="ri-twitter-x-line"></i>
                  <span>Twitter</span>
                </a>
                <a href="https://github.com/nuroveli" className="contact-social-link" target="_blank" rel="noopener noreferrer">
                  <i className="ri-github-line"></i>
                  <span>GitHub</span>
                </a>
                <a href="https://youtube.com/@nuroveli" className="contact-social-link" target="_blank" rel="noopener noreferrer">
                  <i className="ri-youtube-line"></i>
                  <span>YouTube</span>
                </a>
              </div>
            </div>
            
          </div>
          
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
